const DailyKMValues = [ 
    '0',
    '2',
    '5',
    '7',
    '10',
    '15',
    '20',
    '30',
    '40',
    '50',
    '60',
    '70',
    '80',
    '90',
    '100',
    '150',
    '200', 
];

export default DailyKMValues;
